module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';

	fox.registerWidget('Login_Member', {
		configure: function() {
			this.registerOptions('', {
				'widgets.snManager': {
					widget: 'SocialNetwork_Manager',
					autoRender: true,
					mode: 'signin',
					template: 'socialnetwork_oauth_signin_container',
					'embed.container': '.social-fields',

					list: {
						'tpl.row': 'socialnetwork_oauth_signin',
						'embed.container': '#items-block',
						handleDom: {
							socialClick: {
								target: 'a.soc-button',
								event: 'click',
								callback: '@parent:socialClickHandler'
							}
						}
					},

					'handleWom.successLogin': {
						widget: '@this',
						event: 'successLogin',
						callback: '@parent:snLogin'
					},
					'handleWom.readyForReg': {
						widget: '@this',
						event: 'readyForReg',
						callback: '@parent:snConnect'
					}
				},
				'handleDom': {
					snRegister: {
						target: '#reg-from-login',
						event: 'click',
						callback: 'snRegister'
					},
					submitForgotForm: {
						target: '#forgot-form',
						event: 'submit',
						callback: '_submitForgotForm'
					},
					formButtonSubmit: {
						target: '#form-submit',
						event: 'click',
						callback: '_submit' 
					},
					changeForm: {
						target: "#change-form-forgot, #change-form-login",
						event: 'click',
						callback: 'changeForm'
					},
					sendRecoveryMail: {
						target: '#send-forgot',
						event: 'click',
						callback: 'sendRecoveryMail'
					}
				}
			});

			return this.callParent('configure', arguments);
		},

		init: function() {
			this.embedWidget('forgotPassword', 'PasswordRecovery', {});

			return this.callParent('init', arguments);
		},

		running: function() {
			this.forgotPassword = this.requireEmbeddedWidget('forgotPassword');
			this.handleEvent(this.forgotPassword, 'sendRecoveryMail', fox.bind(this.answerSendRecoveryMail, this));

			this.callParent('running', arguments);
		},

		rendering: function() {
			var self = this;
			
			this.callParent('rendering', arguments);

			this.errorBox = $(this.dom('#errors'));
			this.errorsContainer = $(this.dom('#errors .txt'));
			this.inputs = $(this.dom('.field'));
			this.forgot = $(this.dom('.field-forgot'));

			this.loginField = $(this.dom('#email'));
			this.loginField = $(this.dom('#email'));

			fox.dom.on('submit', this.dom1('#login-form'), fox.bind(this.submit, this));
			fox.dom.on('submit', this.dom1('#forgot-form'), fox.bind(this.sendRecoveryMail, this));

			this.inputs.bind('focusin', function() {
				$(this).parent().removeClass('error').addClass('focused');
			});
			this.inputs.bind('focusout', function() {
				var $this = $(this);
				if (fox.trim($this.val()) !== '') {
					self.errorBox.hide();
					self.center();
					return false;
				}

				$(this).parent().removeClass('error').removeClass('focused');

			});

			
			this.forgot.bind('focusin', function() {
				$(this).parent().removeClass('error').addClass('focused');
			});
			this.forgot.bind('focusout', function() {
				$(this).parent().removeClass('error').removeClass('focused');
			});

		},

		sendRecoveryMail: function() {
			var input = fox.dom.selectFirst('#email-forgot', this.element);
			if (!fox.isEmpty(input.value)) {
				this.forgotPassword.sendRecoveryMail(input.value);

				input.readonly = true;
				input.parentNode.style.opacity = 0.5;
			} else {
				var infoForgotElm = fox.dom.selectFirst('#info-forgot', this.element);
				infoForgotElm.parentElement.style.display = 'block';
				infoForgotElm.innerText = 'We are sorry but the e-mail you entered is empty.';

				input.readonly = false;
				input.parentNode.style.opacity = 1;
			}
		},

		answerSendRecoveryMail: function(answer) {
			var infoForgotElm = fox.dom.selectFirst('#info-forgot', this.element);
			var input = fox.dom.selectFirst('#email-forgot', this.element);

			infoForgotElm.parentElement.style.display = 'block';
			infoForgotElm.innerHTML = answer.text;

			input.readonly = false;
			input.parentNode.style.opacity = 1;
		},

		changeForm: function() {
			$(fox.dom.selectFirst('#email-forgot', this.element)).val('');
			$(fox.dom.selectFirst('#login-form', this.element)).toggle();
			$(fox.dom.selectFirst('#forgot-form', this.element)).toggle();
		},

		_submit: function (el, w, alias, e) {
			this.submit(e);
		},

		submit: function(e) {
			var isValid = true;

			!e ? e = window.event : '';
			e.preventDefault ? e.preventDefault() : e.cancelBubble = true;

			this.inputs.each(function(i, field){
				if ( fox.trim(field.value) === '') {
					$(field).parent().addClass('error');
					isValid = false;
				}
			});

			if (isValid) {
				var data = {
					email: fox.trim(encodeURIComponent(fox.dom.selectFirst('#email').value)),
					passwd: fox.trim(encodeURIComponent(fox.dom.selectFirst('#passwd').value))
				};

				var api = this.getApi('authorize', {
					method: 'site.authorizer.auth',
					httpMethod: 'post'
				});

				this.handleEvent(api, 'success', fox.bind(this.formSubmitted, this));
				this.handleEvent(api, ['error', 'failure'], fox.bind(this.formSubmitError, this));
				
				api.send(data, false);

				this.togglePreloader(true);
				this.errorBox.hide();
				this.center();
			} else {
				this.showErrorMessage('Fields shouldn\'t be empty');
			}

			return false;
		},

		formSubmitted: function(data) {
			var response = data.answer.response;
			this.login(response);
		},

		formSubmitError: function(err) {
			this.showErrorMessage(err.answer.reason);
			this.togglePreloader(false);
		},

		showErrorMessage: function(message) {
			var errItem = $('.notice-container .txt p').text(message);
			this.errorsContainer.html('').append(errItem);
			this.errorBox.show();
			this.center();
		},

		snLogin: function(data) {			
			this.login(data);
		},

		snConnect: function(data, w) {
			this.clientProfile = data;
			this.dom1('#sn-login-' + w.appName + '-notice').style.display = 'block';
		},
		
		snRegister: function() {
			fox.cookie.set('snProfile', JSON.stringify(this.clientProfile));
			fox.site.gotoPage('home/registration');			
		},

		login: function(response) {
			this.togglePreloader(false);
			//console.log(response);
			
			if (response && response[0] === 'studio') {
				window.location.assign(['http://agency.', window.location.host, '/'].join(''));
			}
			
			if (!response.member) {
				// error
				return;
			}

			fox.log('logged in, hash: "' + response.hash + '", member: ' + response.member.collection);
			if (response.home) {
				fox.site.setOption('home', response.home);
			}
			if (response.site) {
				fox.each(response.site, function(value, alias) {
					fox.setEnv('public.' + alias, value);
				});
			}

			window.location.reload(true);
		},

		togglePreloader: function(state) {
			var btn = this.dom1('#form-submit');

			if (!btn) {
				return;
			}

			fox.dom[(state ? 'addClass' : 'removeClass')]('spin', btn);
		},

		center: function (argument) {
			/*var form = $('.form.login-form');
			var cont = $('.promo-page-container');

			if (form.css('position') == 'absolute') {
				form.css('marginTop', (-(form.height() + 27)/2) + 'px');
				cont.css('minHeight', '990px');

				return
			};

			form.css('marginTop', 0);
			cont.css('minHeight', '920px');*/
		},

		changeFormPosition: function () {
			/*window.setTimeout(function(argument) {
				if ($('.guest-form').height() < $('.form').height()) {
					$('.promo-wrapper').addClass('static');

					return;
				};
			}, 500);*/
		},

		_submitForgotForm: function (el, alias, w, e) {
			fox.dom.event.stop(e);

			this.sendRecoveryMail();

			return false;
		}

	});
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/login/member.js
// module id = 37
// module chunks = 2